/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Divider, Flex, Text, useToast } from '@chakra-ui/react'
import 'pdfjs-dist/build/pdf.worker.entry'
import React, { useState } from 'react'
import { FaArrowRight, FaEnvelope } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../components/InputCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { SelectCmp } from '../../../../components/SelectCmp'
import { SwitchCmp } from '../../../../components/SwitchCmp'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { appApi } from '../../../../services/appApi'
import { ValidaCPF, ValidarEmail } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { BoxArquivo } from '../components/BoxArquivo/BoxArquivo'

interface IListaPerfilDTO{
  totalRegistrosEncontrados: number
  totalPaginas: number
  resultadoBusca: IperfilDto2[]
}

export interface IperfilDto2 {
  assessmentId: string
  assessmentUserId: string
  email: string
  nome: string
  dataConclusao: string
  pi: number
  self: iSelf
  selo: iSelo
}

interface iSelf {
  aSigma: number
  bSigma: number
  cSigma: number
  dSigma: number
  eSigma: number
  mScore: number
}

interface iSelo {
  definicao: string
  nome: string
  urlAvatar: string
}

// interface IFormData{

//   nome: string
//   email: string
//   cpf: string
//   linkedin?: string
//   cargo?: File
//   curriculo?: File

// }
interface IAnalise {
  nome: string
  email: string
  pi: string
  cpf: string
  pdfCurriculo?: string
  linkedin?: string
  assessmentId: string
  descritivoCargo?: string
  nomeGestor: string
  emailGestor: string
  assessmentIdGestor: string
  quadroDesenvolvimento: string
  guiaRelacionamentoGestor: string
  imageSelf?: string
  nomeCargo: string
  imageSelfGestor: string
  nomeBP: string
  emailBP: string
  performance?: string
  nomeSolicitante: string
  emailSolicitante: string
  tipoCandidato: number
  nineBox?: string
  cargoAtual?: string
  localidadeCidade?: string
  localidadeRegional?: string
  responsavelVaga?: string
}

interface iModel {
  nome: string
  cpf: string
  email: string
}
interface iResultCadastro {
  sucesso: boolean
  msg: string
  erro: string
}

interface iModelSolicitante {
  nomeSolicitante: string
  emailSolicitante: string
}

export const SendSIStage1: React.FC = () => {
  // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)
  const [IsInvalid, setIsInvalid] = useState(false)
  const [TipoCandidato, setTipoCandidato] = useState(0)
  const [ModelColaborador, setModelColaborador] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [ModelGestor, setModelGestor] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [BP, setBP] = useState<iModel>({ cpf: '', email: '', nome: '' })

  // const { register, handleSubmit } = useForm<IFormData>()
  const [NineBox, setNineBox] = useState('')
  const [descricaoCargo, setDescricaoCargo] = useState('')
  const [NomeCargo, setNomeCargo] = useState('')
  const [CargoAtual, setCargoAtual] = useState('')
  const [LocalidadeRegional, setLocalidadeRegional] = useState('')
  const [LocalidadeCidade, setLocalidadeCidade] = useState('')
  const [ResponsavelVaga, setResponsavelVaga] = useState('')
  const [curriculo, setCurriculo] = useState('')
  const [urlCurriculo, setUrlCurriculo] = useState('')
  const [Model, setModel] = useState<iModelSolicitante>({ nomeSolicitante: '', emailSolicitante: '' })
  const [RelatorioPerformance, setRelatorioPerformance] = useState('')

  const [autenticado, setAutenticado] = useState(false)
  const [login, setLogin] = useState('')
  const [codigo, setCodigo] = useState('')
  const [protocolo, setProtocolo] = useState('')
  const [Concluido, setConcluido] = useState(false)

  function btnIniciarHandle(): void {
    const validacao = validarEmailECodigo(login, codigo)
    if (validacao) {
      toast({
        title: 'Acesso válido',
        status: 'success',
        duration: 4000,
        position: 'top'
      })
      setAutenticado(validacao)
      return
    }

    toast({
      title: 'Acesso negado',
      description: 'Verifique email e codigo',
      status: 'error',
      duration: 4000,
      position: 'top'
    })
    setAutenticado(validacao)
  }

  function validarEmailECodigo(email: string, cod: string): boolean {
    const dominioRegex = /^[^\s@]+@claro\.[^\s@]+$/i
    const codigoValido = 'cl@roRH#2025SAH'
    return dominioRegex.test(email.toLowerCase()) && cod === codigoValido
  }

  const onSubmit = (): void => {
    setIsInvalid(false)

    if (descricaoCargo === '') {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo de descrição da vaga',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (NomeCargo === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do cargo',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (curriculo === '' && urlCurriculo === '') {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo de currículo ou preencha com a url do linkedin',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelColaborador.nome || ModelColaborador.nome === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (ModelColaborador.nome.split(' ').length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha nome e sobrenome do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelColaborador.email || ModelColaborador.email === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!BP.nome || BP.nome === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do business partner',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!Model.nomeSolicitante || Model.nomeSolicitante === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do solicitante',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (BP.nome.split(' ').length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha nome e sobrenome do business partner',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!BP.email || BP.email === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do business partner',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!Model.emailSolicitante || Model.emailSolicitante === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do solicitante',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (ModelColaborador.cpf.length > 0 && !ValidaCPF(ModelColaborador.cpf)) {
      setIsInvalid(true)
      toast({
        title: 'Preencha corretamente o CPF do colaborador',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelGestor.nome || ModelGestor.nome === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o nome do Gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (ModelGestor.nome.split(' ').length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha nome e sobrenome do gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (!ModelGestor.email || ModelGestor.email === '') {
      setIsInvalid(true)
      toast({
        title: 'Preencha o email do Gestor',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    if (TipoCandidato === 0 && CargoAtual.length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Preencha Cargo atual do candidato',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }
    if (TipoCandidato === 0 && NineBox.length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Selecione o Qudrante do 9Box do candidato',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }
    if (ResponsavelVaga.length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Informe RP',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }
    if (NomeCargo.length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Informe o nome do cargo',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }
    if (LocalidadeCidade.length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Informe a cidade da vaga',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }
    if (LocalidadeRegional.length < 2) {
      setIsInvalid(true)
      toast({
        title: 'Informe a Regional da vaga',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    const payload: IAnalise = {
      nome: ModelColaborador.nome,
      email: ModelColaborador.email,
      cpf: ModelColaborador.cpf,
      descritivoCargo: descricaoCargo,
      pdfCurriculo: curriculo,
      assessmentId: '',
      nomeGestor: ModelGestor.nome,
      emailGestor: ModelGestor.email,
      linkedin: urlCurriculo,
      nomeCargo: NomeCargo,
      nomeBP: BP.nome,
      emailBP: BP.email,
      performance: RelatorioPerformance,
      nomeSolicitante: Model.nomeSolicitante,
      emailSolicitante: Model.emailSolicitante,
      tipoCandidato: TipoCandidato,
      nineBox: NineBox !== '' ? NineBox : undefined,
      assessmentIdGestor: '',
      pi: '',
      guiaRelacionamentoGestor: '',
      imageSelfGestor: '',
      quadroDesenvolvimento: '',
      cargoAtual: CargoAtual,
      responsavelVaga: ResponsavelVaga,
      localidadeCidade: LocalidadeCidade,
      localidadeRegional: LocalidadeRegional
    }

    setIsLoading(true)
    try {
      appApi.post<iResultCadastro>('api/SI/CadastrarPreAnalise', payload)
        .then(r => Finalizar(r.data.msg))
        .catch(err => console.log(err)).finally(() => setIsLoading(false))
      // appApi.post('api/SI/Analisar', payload).then(r => console.log(r)).catch(err => console.log(err))
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  function GetIsInvalid(val: string): boolean {
    return val === '' && IsInvalid
  }

  function Finalizar(msg: string): void {
    setProtocolo(msg)
    setConcluido(true)
    setLogin('')
    setCodigo('')

    setTipoCandidato(0)
    setModelColaborador({ cpf: '', email: '', nome: '' })
    setModelGestor({ cpf: '', email: '', nome: '' })
    setBP({ cpf: '', email: '', nome: '' })

    setNineBox('')
    setDescricaoCargo('')
    setNomeCargo('')
    setCurriculo('')
    setUrlCurriculo('')
    setModel({ nomeSolicitante: '', emailSolicitante: '' })
    setRelatorioPerformance('')
    setAutenticado(false)
  }

  const handleFileCargoChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.includes('.docx') && !file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".docx" ou ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setDescricaoCargo(reader.result as string)
      }
    }
  }
  const handleFileCurriculoChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setCurriculo(reader.result as string)
      }
    }
  }

  const handleFilePerformanceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file?.name.includes('.docx') && !file?.name.toLowerCase().includes('.pdf')) {
      toast({
        title: 'O arquivo deve ser no formato ".docx" ou ".PDF" para ser aceito',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      event.target.value = ''
      return
    }
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setRelatorioPerformance(reader.result as string)
      }
    }
  }

  return (
    <LoadingContainer linhas={42} loading={IsLoading} px='3rem' my='3rem'>
      <Body isLoading={IsLoading}>
        <WhiteContainer margin='.5rem 0 1rem 0'>
          <Flex direction='column' minHeight={'400px'} gap={'1.25rem'}>
            {Concluido &&
            <Flex alignSelf={'center'} flexDir={'column'} justifyContent='center' alignItems={'center'} bgColor='green.200' p='5rem'>
              <h2>Solicitação cadastrada com sucesso! </h2>
              <h3># {protocolo}</h3>
              <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray2)'}>Recebemos sua solicitação para relatório PRISMAH assim que for processado os responsáveis indicados receberão um email.</Text>
            </Flex>
            }
            {!Concluido &&
            <Flex flexDir={'column'}>
              <h2>Solicitar Relatório PRISMAH</h2>
              <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray2)'}>Informe os dados do candidato e da vaga</Text>
            </Flex>
            }

            {!Concluido && !autenticado && <>
            <InputCmp
              label='Email'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(login)}
              OnChange={(s) => setLogin(s)} placeholder='Digite o seu email' />

            <InputCmp
              label='Código de acesso'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(codigo)}
              type={'password'}
              OnChange={(s) => setCodigo(s)} placeholder='Digite o código recebido pelo RH' />

            <ElementoTooltipCmp label={ModelColaborador.nome === '' ? 'Preencha o seu email e código de acesso para prosseguir' : ''} bg={'var(--Red)'}>
                <ButtonCmp leftIcon={<FaArrowRight/>} w='16rem' isDisabled={login === ''} onClick={() => { btnIniciarHandle() }} VarColor='Azul'>
                    Iniciar
                </ButtonCmp>
              </ElementoTooltipCmp>

            <Divider opacity={'.8'} borderColor={'var(--Azul)'} my={'.75rem'}/>
              </>}

              {!Concluido && autenticado && <>
            <InputCmp
              label='Nome do candidato'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(ModelColaborador.nome)}
              OnChange={(s) => setModelColaborador({ ...ModelColaborador, nome: s })} placeholder='Digite o nome do candidato' />

            <InputCmp
              label='Email do candidato'
              isInvalid={GetIsInvalid(ModelColaborador.email) || (ModelColaborador.email.length > 0 && !ValidarEmail(ModelColaborador.email))}
              errorBorderColor='red.300'
              OnChange={(s) => setModelColaborador({ ...ModelColaborador, email: s })} value={ModelColaborador.email} placeholder='Digite o email do candidato' />

            <InputCmp
              label='CPF do candidato'
              isInvalid={IsInvalid && (ModelColaborador.cpf.length > 0 && (ModelColaborador.cpf.length < 11 || !ValidaCPF(ModelColaborador.cpf)))}
              errorBorderColor='red.300'
              OnChange={(s) => setModelColaborador({ ...ModelColaborador, cpf: s })} value={ModelColaborador.cpf} placeholder='Digite o CPF do candidato' />
             <div>
             <Text fontSize={'14px'}
              mb={'.25rem'}
              fontWeight={'medium'} color={'var(--Gray1)'}>Origem do candidato</Text>
            <SwitchCmp OnChange={(val) => val ? setTipoCandidato(1) : setTipoCandidato(0) } legendaEsquerda='Candidato Interno' legendaDireita='Candidato Externo' value={TipoCandidato === 1}/>
             </div>
            {TipoCandidato === 0 &&
            <><SelectCmp title='9Box do candidato' value={NineBox} OnChange={setNineBox}>
                  <option value={''}>Selecione o 9box do candidato</option>
                  <option value={'Aposta'}>Aposta</option>
                  <option value={'Atenção'}>Atenção</option>
                  <option value={'Crítico'}>Crítico</option>
                  <option value={'Destaque'}>Destaque</option>
                  <option value={'Eficaz'}>Eficaz</option>
                  <option value={'Eficiente'}>Eficiente</option>
                  <option value={'Importante'}>Importante</option>
                  <option value={'Observação'}>Observação</option>
                  <option value={'Talento'}>Talento</option>
                </SelectCmp><InputCmp
                    label='Cargo atual do colaborador'
                    errorBorderColor='red.300'
                    OnChange={(s) => { setCargoAtual(s) } } value={CargoAtual} placeholder='Digite o Cargo atual do colaborador' /></>
            }

              <InputCmp
                label='LinkedIn do candidato'
                errorBorderColor='red.300'
                OnChange={(s) => { setUrlCurriculo(s) }} value={urlCurriculo} placeholder='Digite a url do linkedIn' />

<Divider opacity={'.9'} borderColor={'var(--c6)'} mt={'.75rem'}/>
            <InputCmp
            label='RP'
            isInvalid={GetIsInvalid(ResponsavelVaga)}
            errorBorderColor='red.300'
            OnChange={(s) => setResponsavelVaga(s)
            } value={Model.nomeSolicitante} placeholder='Digite o RP' />

            <InputCmp
              label='Nome do cargo'
              isInvalid={GetIsInvalid(NomeCargo)}
              errorBorderColor='red.300'
              OnChange={(s) => { setNomeCargo(s) }} value={NomeCargo} placeholder='Digite o nome do cargo' />

            <InputCmp
              label='Localidade / Cidade'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(LocalidadeCidade)}
              OnChange={(s) => setLocalidadeCidade(s)} placeholder='Digite a cidade da vaga' />
            <InputCmp
              label='Localidade / Regional'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(LocalidadeRegional)}
              OnChange={(s) => setLocalidadeRegional(s)} placeholder='Digite o nome da Regional' />

            <InputCmp
              label='Nome do gestor'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(ModelGestor.nome)}
              OnChange={(s) => setModelGestor({ ...ModelGestor, nome: s })} placeholder='Digite o nome do gestor' />

            <InputCmp
              label='Email do gestor'
              isInvalid={GetIsInvalid(ModelGestor.email) || (ModelGestor.email.length > 0 && !ValidarEmail(ModelGestor.email))}
              errorBorderColor='red.300'
              OnChange={(s) => setModelGestor({ ...ModelGestor, email: s })} value={ModelGestor.email} placeholder='Digite o email do gestor' />

            <InputCmp
              label='Nome do BP (business partner)'
              errorBorderColor='red.300'
              isInvalid={GetIsInvalid(BP.nome)}
              OnChange={(s) => setBP({ ...BP, nome: s })} placeholder='Digite o nome do business partner' />

            <InputCmp
              label='Email do BP (business partner)'
              isInvalid={GetIsInvalid(BP.email) || (BP.email.length > 0 && !ValidarEmail(BP.email))}
              errorBorderColor='red.300'
              OnChange={(s) => setBP({ ...BP, email: s })} value={BP.email} placeholder='Digite o email do business partner' />

            <InputCmp
              label='Nome do recrutador'
              isInvalid={GetIsInvalid(Model.nomeSolicitante)}
              errorBorderColor='red.300'
              OnChange={(s) => setModel({ ...Model, nomeSolicitante: s })} value={Model.nomeSolicitante} placeholder='Digite o nome do recrutador' />

              <InputCmp
                label='Email do recrutador'
                isInvalid={GetIsInvalid(Model.emailSolicitante) || (Model.emailSolicitante.length > 0 && !ValidarEmail(Model.emailSolicitante))}
                errorBorderColor='red.300'
                OnChange={(s) => setModel({ ...Model, emailSolicitante: s })} value={Model.emailSolicitante} placeholder='Digite o email do recrutador' />

            <Flex flexDir={'column'} gap={'1.75rem'}>

            </Flex>

              </>}

          </Flex>
          {!Concluido && autenticado && <>
          <Flex flexDir={'column'} gap={'1.75rem'} mt={'1rem'}>
            <Divider opacity={'.9'} borderColor={'var(--c6)'} mt={'.75rem'}/>
   <Text fontWeight={700} fontSize={'18px'}>Arquivos obrigatórios</Text>
              <Flex alignItems={'center'} justifyContent={'center'} flexWrap={'wrap'} gap={'3rem'}>
                <BoxArquivo
                  title='Currículo'
                  isOpcional={false}
                  AtualizarArquivo={handleFileCurriculoChange}
                  id={'fileCurriculo'}
                  tipo={1}
                />
                <BoxArquivo
                  isOpcional={false}
                  title='Descrição da vaga'
                  AtualizarArquivo={handleFileCargoChange}
                  id={'fileCargo'}
                  tipo={2}
                />
            </Flex>

            <Text fontWeight={700} fontSize={'18px'}>Arquivos opcionais</Text>
            <Flex alignItems={'center'} justifyContent={'start'} flexWrap={'wrap'} gap={'3rem'}>
              <BoxArquivo
                title='Relatório de performance'
                isOpcional={true}
                AtualizarArquivo={handleFilePerformanceChange}
                id={'filePerformance'}
                tipo={1}
              />
            </Flex>
          </Flex>
          </>}
        </WhiteContainer>
          {!Concluido && autenticado && <>
        <Flex justifyContent={'end'} >
          <ButtonCmp leftIcon={<FaEnvelope/>} onClick={onSubmit} VarColor='Rosa' size='xs' w='16rem'>
            Cadastrar solicitação
          </ButtonCmp>
        </Flex>
          </>}
      </Body>
    </LoadingContainer>
  )
}
